export default __webpack_public_path__ + "static/media/38_desktop.2b3f129c.jpg";